<template>
	<div
		class="steps__step"
		:class="( is_completed_step ) ? ' steps__step--completed' : ( is_current_step ) ? ' steps__step--active' : null"
	>
		<div class="steps__step-number">
			{{ step.step_number }}
		</div>
		<div class="steps__step-title-wrapper">
			<h2 class="steps__step-title">
				{{ step.title }}
			</h2>
		</div>
		<template v-if="is_current_step">
			<div class="steps__step-form">
				<form
					@submit.prevent="updateForm"
				>
					<div
						v-if="total"
						class="project-review"
					>
						<p class="project-review__total">
							<span>Total cost</span>
							<span class="project-review__total-amount">{{ total }}</span>
						</p>
					</div>

					<button
						class="button button--fill"
						:class="{ 'button--loading': loading}"
						type="submit"
						:disabled="loading"
					>
						Add Scope
					</button>
				</form>
			</div>
		</template>
	</div>
</template>

<script setup>
import { useAddProjectScopeStore } from '../../stores/add-project-scope.js';
import { ref, computed, defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import { formatCurrency } from '../../../helpers';

const add_new_project_scope_store = useAddProjectScopeStore();
const { submitNewProjectScope } = add_new_project_scope_store;

const {
	currencies,
	form_fields,
	form_errors
} = storeToRefs( add_new_project_scope_store );

const props = defineProps( {
	step: {
		required: true,
		type: Object
	},
	activeStepNumber: {
		required: true,
		type: Number
	}
} );

const is_current_step = computed( () => {
	return props.step.step_number === props.activeStepNumber;
} );

const is_completed_step = computed( () => {
	return props.step.step_number < props.activeStepNumber;
} );

const selected_currency = computed( () => {
	const selected = currencies.value.find( currency => parseInt( currency.value ) === parseInt( form_fields.value.currency ) );
	return selected ?? { label: 'USD' };
} );

const total = computed( () => {
	if ( !form_fields.value.project_scope || !form_fields.value.project_scope.items?.length ) {
		return null;
	}
	const total_cost = form_fields.value.project_scope.items.reduce( ( acc, val ) => acc + val.total, 0 );
	return formatCurrency( total_cost, selected_currency.value.label )
} );

const loading = ref( false );

async function updateForm() {
	loading.value = true;
	await submitNewProjectScope();
	loading.value = false;
}
</script>
